if (!customElements.get('hafizah-product-payments')) {
  customElements.define('hafizah-product-payments', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const details = this.querySelector('details');
      const summary = details.querySelector('summary');
      const closeButton = this.querySelector('.hz-pdp-payments-close');
      const close = (restoreFocus = false) => {
        details.open = false;
        if (restoreFocus) summary.focus({ preventScroll: true });
      };
      closeButton.hidden = false;
      closeButton.addEventListener('click', () => close(true), { signal });
      this.addEventListener('focusout', () => {
        setTimeout(() => {
          if (details.open && !this.contains(document.activeElement)) close();
        }, 0);
      }, { signal });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          close(true);
        }
      }, { signal });
      document.addEventListener('pointerdown', (event) => {
        if (details.open && !this.contains(event.target)) close();
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
